enum MutationNames {
  SET_SCHOLAR_LIST = 'SET_SCHOLAR_LIST',
  RESET_SCHOLAR_LIST = 'RESET_SCHOLAR_LIST',
  DROPDOWN_SCHOLARS_REQUESTED = 'DROPDOWN_SCHOLARS_REQUESTED',
  DROPDOWN_SCHOLARS_SUCCEEDED = 'DROPDOWN_SCHOLARS_SUCCEEDED',
  DROPDOWN_SCHOLARS_FAILED = 'DROPDOWN_SCHOLARS_FAILED',
  SCRUB_SCHOLAR_IDS_FAILED = 'SCRUB_SCHOLAR_IDS_FAILED',
  SET_DUPLICATE_APPLICATION_ERROR_TYPE = 'SET_DUPLICATE_APPLICATION_ERROR_TYPE',
  SCRUB_SCHOLAR_IDS_SUCCEEDED = 'SCRUB_SCHOLAR_IDS_SUCCEEDED',
  SCRUB_SCHOLAR_IDS_REQUESTED = 'SCRUB_SCHOLAR_IDS_REQUESTED',
  RESET_SELECTED_CHILD = 'RESET_SELECTED_CHILD',
  SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR = 'SET_PROGRAM_DETAILS_LOADING_BY_SCHOLAR',
  SET_SCHOLAR_DOCUMENTS_LOADING = 'SET_SCHOLAR_DOCUMENTS_LOADING',
  SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA = 'SET_IS_LOADING_GET_ADDED_SCHOLAR_DATA'
}

export default MutationNames;